import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FicheIntervention } from 'app/models/ficheIntervention.model';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeEquipementService } from 'app/services/type-equipement.service';
import { TypeEquipement } from 'app/models/typeEquipement.model';

@Component({
  selector: 'app-modal-form-type-equipement',
  templateUrl: './modal-form-type-equipement.component.html',
  styleUrls: ['./modal-form-type-equipement.component.scss']
})
export class ModalFormTypeEquipementComponent implements OnInit {
  success: boolean = false;
  error: boolean = false;

  typeEquipementForm: FormGroup;
  constructor(private typeEquipementService: TypeEquipementService, public dialogRef: MatDialogRef<ModalFormTypeEquipementComponent>) { }

  ngOnInit(): void {
    this.typeEquipementForm = new FormGroup({
      nom: new FormControl(null, [Validators.required]),
    });
  }

  onFormSubmit() {
    this.error = false;
    this.success = false;
    this.typeEquipementForm.markAllAsTouched();

    if (this.typeEquipementForm.valid) {
      const typeEquipement = new TypeEquipement(this.typeEquipementForm.value);
      this.typeEquipementService.store(typeEquipement).subscribe(
        (response) => {
          this.success = true;
          this.dialogRef.close(response);
        }, (error) => { this.error = true; this.showErrors(error); }
      );
    }
  }

  showErrors(error: any) {
    //Gestion des erreurs laravel
    if (error instanceof HttpErrorResponse) {
      for (const key in error.error.errors) {
        // Todo: handle error
      }
    }
    else {
      error.forEach((element) => {
        //this.toastr.error(element);
      });
    }
  }
}
